import { useAccountTypeNavigation } from "@features/tickets/shared/hooks/useAccountTypeNavigation";
import { OUTCOMES_BREADCRUMB, OUTCOMES_PATH, OUTCOMES_STRUCTURE_CRUMBS } from "./outcomes.constants";

export function useOutcomesNavigation() {
  return useAccountTypeNavigation({
    path: OUTCOMES_PATH,
    listBreadcrumb: OUTCOMES_BREADCRUMB.list,
    structureCrumbs: OUTCOMES_STRUCTURE_CRUMBS,
  });
}
